module.exports = __webpack_public_path__ + "img/Rendering RZ Vorderseite 20.08.2009.61742607.jpg";